module.exports = __webpack_public_path__ + "static/media/4-square-unavailable.03aa2784.svg";